import { I18n, setupI18n } from '@lingui/core';
import { messages as fi } from './fi/messages_fi.js';
import { messages as en } from './en/messages_en.js';
import { messages as nb } from './nb/messages_nb.js';
import { messages as da } from './da/messages_da.js';

let i18nInstance: I18n;

export default function getI18n(locale: string = "nb") {
  if (!i18nInstance || i18nInstance.locale !== locale) {
    i18nInstance = setupI18n({ locale });

    i18nInstance.load({
      en,
      nb,
      fi,
      da,
    });
    i18nInstance.activate(locale);
  }

  return i18nInstance;
}
